import { Box, HStack } from 'ui/Layout';
import { Text } from 'ui/Typography';

type Props = {
  label: string;
  value: React.ReactNode;
};

const SankeyFooterInfo: React.FC<Props> = ({ label, value }) => (
  <HStack gap={1}>
    <Text>{label}</Text>
    <Box fontWeight={600}>{value}</Box>
  </HStack>
);

export default SankeyFooterInfo;
